import { GET_ALL_USERS, GET_ALL_TOURS } from "./common/constants";
import { getResponseStatus } from "./common/global";
const backendUrl = import.meta.env.VITE_BACKEND_URL;
const AppUtils = {
  getAllTours: async function () {
    return fetch(GET_ALL_TOURS, {
      method: "GET",
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== "error") return data;
        },
        function (error) {
          console.log("error", error);
        }
      )
      .catch((error) => {
        console.log("error", error);
      });
  },

  getAllUsers: async function () {
    return fetch(GET_ALL_USERS, {
      method: "GET",
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== "error") return data;
        },
        function (error) {
          console.log("error", error);
        }
      )
      .catch((error) => {
        console.log("error", error);
      });
  },

  getTourDetails: async function (expId) {
    return fetch(`${backendUrl}/api/data/${expId}`, {
      method: "GET",
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== "error") return data;
        },
        function (error) {
          console.log("error", error);
        }
      )
      .catch((error) => {
        console.log("error", error);
      });
  },
  getPublishedTours: async function (data) {
    return fetch(`${backendUrl}/api/data/`, {
      method: "GET",
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== "error") return data;
          else alert("Something went wrong");
        },
        function (error) {
          console.log("error", error);
        }
      )
      .catch((error) => {
        console.log("error", error);
      });
  },
  getSupplierById: async function (suppId) {
    return fetch(`${backendUrl}/api/supplier/${suppId}`, {
      method: "GET",
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== "error") return data;
        },
        function (error) {
          console.log("error", error);
        }
      )
      .catch((error) => {
        console.log("error", error);
      });
  },

  checkout: async function (data) {
    return fetch(`${backendUrl}/api/checkout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== "error") return data;    
        },
        function (error) {
          console.log("error", error);
        }
      )
      .catch((error) => {
        console.log("error", error);
      });
  },
  getActivityInfo: async function (data) {
    return fetch(`${backendUrl}/api/tour/list/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== 'error') return data;
          else alert("Something wen't wrong");
        },
        function (error) {
          console.log('error', error);
        },
      )
      .catch((error) => {
        console.log('error', error);
      });
  },
  getFilteredTours: async function (data) {
    return fetch(`${backendUrl}/api/tour/list/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(
        async (response) => {
          let data = await getResponseStatus(response);
          if (data !== 'error') return data;
          else alert("Something wen't wrong");
        },
        function (error) {
          console.log('error', error);
        },
      )
      .catch((error) => {
        console.log('error', error);
      });
  },
  getAccountExists: async function (email) {
    return fetch(`${backendUrl}/api/user/${email}`, {
      method: "GET",
    }).then(async (response) =>{
      let data = await getResponseStatus(response);
      console.log("data", data);
          if (data !== "error") return data;
    }).catch((err) => console.log(err))
  }
};

export default AppUtils;
